import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { Route } from 'vue-router';
import { User } from '@/store/modules/auth/types';
import Template from './template.vue';

const namespace: string = 'authModule';

interface Aviso {
  visible: boolean;
  timeout: number;
  color: string;
  texto: string;
}

Component.registerHooks(['beforeRouteEnter']);

@Component({
  mixins: [Template],
})
export default class Login extends Vue {
  private user: Partial<User> = {};
  private aviso: Partial<Aviso> = {};
  @State('isLogged', { namespace }) private isLogged!: boolean;
  @State('error', { namespace }) private error!: boolean;
  @State('errorMessage', { namespace }) private errorMessage!: string;
  @State('loading') private loading?: boolean;
  @State('user', { namespace }) private currentUser!: User;
  // tslint:disable-next-line: ban-types
  @Action('login', { namespace }) private login!: Function;

  private titulo: string = 'ICMA CMS';

  private async beforeRouteEnter(from: Route, to: Route, next: any) {
    next((vm: Login) => {
      if (vm.isLogged === true) {
        next('/');
      }
    });
  }

  private signIn(): void {
    console.log('signIn');
    console.log(this.user);
    this.login(this.user).then(() => {
      if (this.error) {
        // this.$dialog.message.error(this.errorMessage, {
        //   position: 'top',
        // });
      } else {
        let n = 'Ingresando';
        console.log(this.currentUser);
        if (this.currentUser) {
          n += ', ' + this.currentUser.name;
        }
        // const n: string = this.user.name || '';
        this.$dialog.message.info(n, {
          position: 'top',
        });
        // this.muestraAvisoOk('Bienvenido');
        this.$router.push('/');
      }
    });
  }

  // private muestraAvisoOk(m: string): void {
  //   this.aviso.timeout = 3000;
  //   this.aviso.visible = true;
  //   this.aviso.color = '#61c10c';
  //   this.aviso.texto = m;
  // }
}
